/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface EmployerResponse {
  id: string;
  org_id: string;
  name: string;
  description?: string | null;
  website?: string | null;
  cover_url?: string | null;
  is_default: boolean;
  is_archived: boolean;
  mission_vision?: string | null;
  funding_traction?: string | null;
  culture_principles?: string | null;
  benefits?: string | null;
  created_at: string;
  updated_at: string;
}
